// src/pages/ClassReport.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import colors from '../Constants/colors';

const ClassReport = () => {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('');
  const [filterGender, setFilterGender] = useState('');
  const [filterFinancial, setFilterFinancial] = useState('');
  const [teacherClass, setTeacherClass] = useState('');
  const [teacherSection, setTeacherSection] = useState('');
  const [message, setMessage] = useState('');
 const currentSessionId = localStorage.getItem('currentSessionId');

 useEffect(() => {
  async function fetchTeacherData() {
     const teacher = JSON.parse(localStorage.getItem('teacher'));
const teacherId = teacher?.id;
    try {


const sessionId = localStorage.getItem('currentSessionId');

const response = await axios.get(
  `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}`,
  {
    params: { sessionId }
  }
);


      const teacherData = response.data;

      if (!teacherData.classIncharge) {
        setMessage('You are not in charge of any class.');
        return;
      }

      let className = '';
      let sectionName = '';

      if (teacherData.classIncharge.includes('-')) {
        [className, sectionName] = teacherData.classIncharge
          .split('-')
          .map(v => v.trim());
      } else if (teacherData.classIncharge.includes('(')) {
        className = teacherData.classIncharge.split('(')[0].trim();
        sectionName = teacherData.classIncharge
          .split('(')[1]
          .replace(')', '')
          .trim();
      }

      setTeacherClass(className);
      setTeacherSection(sectionName);
    } catch (error) {
      console.error('Error fetching teacher data:', error);
    }
  }

  fetchTeacherData();
}, []);

  useEffect(() => {
    if (teacherClass && teacherSection) {
      async function fetchStudents() {
        try {
          const studentsResponse = await  axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`, {
  params: {
    sessionId: currentSessionId,
    class: teacherClass,
    section: teacherSection,
    status: 'active'
  },
});

          // const activeStudents = studentsResponse.data.filter(
          //   (student) =>
          //     student.status === 'active' &&
          //     student.class === teacherClass &&
          //     student.section === teacherSection
          // );
          setStudents(studentsResponse.data);
          setFilteredStudents(studentsResponse.data);
        } catch (error) {
          console.error('Error fetching students:', error);
        }
      }
      fetchStudents();
    }
  }, [teacherClass, teacherSection]);

  const handleSearch = () => {
    let temp = [...students];


    if (searchTerm) {
      temp = temp.filter(
        (s) =>
          s.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          s.rollNo.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    if (filterCategory) temp = temp.filter((s) => s.category === filterCategory);
    if (filterGender) temp = temp.filter((s) => s.gender === filterGender);
    if (filterFinancial) temp = temp.filter((s) => s.financial === filterFinancial);

    setFilteredStudents(temp);
  };

  const exportToExcel = () => {
    const data = filteredStudents.map((student, index) => ({
      'Sr No.': index + 1,
      'Roll Number': student.rollNo,
      'Student Name': `${student.firstName} ${student.lastName}`,
      "Father's Name": student.fatherName,
      Class: `${student.class} (${student.section})`,
      ...(filterCategory ? { Category: student.category } : {}),
      ...(filterGender ? { Gender: student.gender } : {}),
      ...(filterFinancial ? { 'Financial Status': student.financial } : {}),
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Class Report');
    XLSX.writeFile(workbook, 'ClassReport.xlsx');
  };

  return (
    <div className="min-h-screen bg-white flex justify-center">
      <div className="max-w-7xl w-full px-6 lg:pl-34 py-12">
        <header className="mb-10 text-center sm:text-left">
          <h1 className="text-4xl font-bold  text-gray-900">
            Class Report: {teacherClass} ({teacherSection})
          </h1>                                                   
        </header>
        {/* Filters */}
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-xs">
          <input
            type="text"
            placeholder="Search by Name or Roll Number"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="p-2 border border-gray-300 rounded w-full"
          />
          <select
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
            className="p-2 border border-gray-300 rounded w-full"
          >
            <option value="">Category</option>
            <option value="General">General</option>
            <option value="SC">SC</option>
            <option value="ST">ST</option>
            <option value="OBC">OBC</option>
            <option value="Minority">Minority</option>
            <option value="Any Other">Any Other</option>
          </select>
          <select
            value={filterGender}
            onChange={(e) => setFilterGender(e.target.value)}
            className="p-2 border border-gray-300 rounded w-full"
          >
            <option value="">Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="others">Others</option>
          </select>
          <select
            value={filterFinancial}
            onChange={(e) => setFilterFinancial(e.target.value)}
            className="p-2 border border-gray-300 rounded w-full"
          >
            <option value="">Financial Status</option>
            <option value="apl">APL</option>
            <option value="bpl">BPL</option>
            <option value="ews">EWS</option>
          </select>
          <button
            onClick={handleSearch}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 w-full md:w-auto"
          >
            <i className="fas fa-search mr-2"></i>Search
          </button>
        </div>

        {/* Total Students */}
        <div className="flex justify-start items-center bg-blue-50 text-blue-700 p-4 rounded mb-8">
          <i className="fas fa-users text-2xl mr-2"></i>
          <p className="text-lg font-semibold">Total Students: {filteredStudents.length}</p>
        </div>

        {/* Cards for Students */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredStudents.map((student, idx) => (
            <div
              key={student._id}
              className="bg-gray-100 rounded-lg p-6 hover:shadow-lg transition-transform transform hover:scale-105"
              style={{ boxShadow: `0 4px 8px ${colors.cardShadow}` }}
            >
              <div className="flex items-center mb-4">
                <i className="fas fa-user-graduate text-3xl mr-3 text-green-600"></i>
                <h2 className="text-xl font-semibold text-gray-900">
                  {student.firstName} {student.lastName}
                </h2>
              </div>
              <p className="text-gray-700 mb-2">
                <strong>Roll No:</strong> {student.rollNo}
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Father's Name:</strong> {student.fatherName}
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Class:</strong> {student.class} ({student.section})
              </p>
              {filterCategory && (
                <p className="text-gray-700 mb-2">
                  <strong>Category:</strong> {student.category}
                </p>
              )}
              {filterGender && (
                <p className="text-gray-700 mb-2">
                  <strong>Gender:</strong> {student.gender}
                </p>
              )}
              {filterFinancial && (
                <p className="text-gray-700 mb-2">
                  <strong>Financial Status:</strong> {student.financial}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Export Button */}
        <div className="flex justify-end mt-8">
          <button
            onClick={exportToExcel}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
          >
            <i className="fas fa-file-excel mr-2"></i>Export to Excel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClassReport;
